<template>
  <dc-layout-main>
    <dc-layout-content>
      <cos-table
        serial
        :columns="columns"
        @fetch="fetch"
        v-model:search="queryForm"
        ref="tableRef"
        tableId="DcCosEmployeeAreaSetting"
      >
        <template #search>
          <a-form :model="queryForm">
            <dc-form-item name="employeeNo" label="员工工号">
              <a-input v-model:value="queryForm.employeeNo" allowClear placeholder="请输入" />
            </dc-form-item>
            <dc-form-item name="userName" label="员工名称">
              <a-input v-model:value="queryForm.userName" allowClear placeholder="请输入" />
            </dc-form-item>
            <dc-form-item name="deptId" label="部门">
              <CosCascader
                :fieldNames="{ label: 'label', value: 'id' }"
                :options="deptInfoList"
                type="search"
                v-model:ids="queryForm.deptList"
                max-tag-count="responsive"
                :changeOnSelect="true"
                placeholder="请选择部门"
              />
            </dc-form-item>
            <dc-form-item name="status" label="在职状态">
              <a-select
                v-model:value="queryForm.status"
                allowClear
                placeholder="请选择"
                :options="statusEnum"
              />
            </dc-form-item>
          </a-form>
        </template>
        <template #button>
          <a-button type="primary" @click="addEdit()" v-permission="'lbu_employareaset_add_btn'">新增</a-button>
        </template>
        <template #bodyCell="{ column, record }">
          <template v-if="column.dataIndex === 'riskLevel'">
            <p>{{ ['低', '中', '高'][record.riskLevel - 1] || '--' }}</p>
          </template>
          <template v-if="column.dataIndex === 'action'">
            <more-button>
              <a-button type="link" @click="addEdit(record)" v-permission="'lbu_employareaset_edit_btn'"
                >分配区域</a-button
              >
            </more-button>
          </template>
        </template>
      </cos-table>
      <editModal ref="editModalRef" @success="success" />
    </dc-layout-content>
  </dc-layout-main>
</template>
<script lang="ts">
import editModal from './components/editModal.vue'
import { reactive, ref, computed, onMounted } from 'vue'
import { getuserCustomerAreaList, getDeptInfo } from '@/api/common'
import { BigScoreBakcData } from '@/typings/api/gucangSale'
export default { name: 'DcCosLbuEmployeeAreaSetting' }
</script>
<script setup lang="ts">
const editModalRef = ref<{ toggle:(row?: BigScoreBakcData) => void }>()

const tableRef = ref()
const deptInfoList = ref([])
const queryForm = reactive({
  employeeNo: '',
  userName: '',
  deptList: [],
  status: 1
})

// 获取列表
const fetch = async (params: object, callBack: (res: any) => void) => {
  const res = await getuserCustomerAreaList({ ...params, appId: 'cos_lbu' })
  callBack(res)
}
// 获取直接架构部门(与产品沟通过，不需要过滤)
const fetchDeptInfo = async () => {
  const res = await getDeptInfo({})
  deptInfoList.value = res.data?.deptInfo[0]?.children
}
const success = () => {
  tableRef.value.fetch()
}
onMounted(() => {
  fetchDeptInfo()
})

const statusEnum = [
  { value: 0, label: '离职' },
  { value: 1, label: '在职' }
]

const columns = computed(() => [
  { title: '员工名称', dataIndex: 'userName' },
  { title: '员工工号', dataIndex: 'employeeNo' },
  { title: '在职状态', dataIndex: 'status', dicData: statusEnum },
  { title: '上级名称 ', dataIndex: 'managerName' },
  { title: '部门 ', dataIndex: 'deptName' },
  { title: '客户区域 ', dataIndex: 'areaName' },
  { title: '操作人 ', dataIndex: 'operatorName' },
  { title: '操作时间 ', dataIndex: 'createTime' },

  {
    title: '操作',
    dataIndex: 'action',
    fixed: 'right'
  }
])
const addEdit = (_row?: BigScoreBakcData) => {
  editModalRef.value?.toggle(_row)
}
// const deleteRow = (row: BigScoreBakcData) => {
//   Modal.delete({
//     name: row.customerName,
//     onOk() {
//       deleteBiLoseWarning(row.id).then(() => {
//         DcMessage.success('删除成功')
//         success()
//       })
//     }
//   })
// }
</script>

<style scoped></style>
